import { AccountPageLayout } from "./AccountPageLayout";
import styles from "./styles/Account.module.css";

export const Error = ({ title, errorMessage }) => {
  return (
    <AccountPageLayout title={title}>
      <div className={styles.spinner}>
        <p>{errorMessage}</p>
      </div>
    </AccountPageLayout>
  )
}